module.exports = __webpack_public_path__ + "static/media/optimized.1502174e.png";